import DomUtils from 'lg-vue-components/services/domUtils';

export default {
  name: 'visibility-change',
  mounted: (el, binding) => {
    // eslint-disable-next-line
    var oldVisible;
    // eslint-disable-next-line
    el.onVisibilityChange = (event) => {
      const visible = DomUtils.isElementInViewport(el);

      if (visible !== oldVisible) {
        oldVisible = visible;
        binding.value(event, el, visible);
      }
    };

    el.parentElement.addEventListener('DOMContentLoaded', el.onVisibilityChange, false);
    el.parentElement.addEventListener('load', el.onVisibilityChange, false);
    el.parentElement.addEventListener('scroll', el.onVisibilityChange, false);
    el.parentElement.addEventListener('resize', el.onVisibilityChange, false);

    document.addEventListener('DOMContentLoaded', el.onVisibilityChange, false);
    document.addEventListener('load', el.onVisibilityChange, false);
    document.addEventListener('scroll', el.onVisibilityChange, false);
    document.addEventListener('resize', el.onVisibilityChange, false);

    window.addEventListener('DOMContentLoaded', el.onVisibilityChange, false);
    window.addEventListener('load', el.onVisibilityChange, false);
    window.addEventListener('scroll', el.onVisibilityChange, false);
    window.addEventListener('resize', el.onVisibilityChange, false);
  },
  unmounted: (el) => {
    el.parentElement.removeEventListener('DOMContentLoaded', el.onVisibilityChange, false);
    el.parentElement.removeEventListener('load', el.onVisibilityChange, false);
    el.parentElement.removeEventListener('scroll', el.onVisibilityChange, false);
    el.parentElement.removeEventListener('resize', el.onVisibilityChange, false);

    document.removeEventListener('DOMContentLoaded', el.onVisibilityChange, false);
    document.removeEventListener('load', el.onVisibilityChange, false);
    document.removeEventListener('scroll', el.onVisibilityChange, false);
    document.removeEventListener('resize', el.onVisibilityChange, false);

    window.removeEventListener('DOMContentLoaded', el.onVisibilityChange, false);
    window.removeEventListener('load', el.onVisibilityChange, false);
    window.removeEventListener('scroll', el.onVisibilityChange, false);
    window.removeEventListener('resize', el.onVisibilityChange, false);
  },
};
